import { render, staticRenderFns } from "./MitMyEventsPage.vue?vue&type=template&id=2ddcfdea&scoped=true"
import script from "./MitMyEventsPage.vue?vue&type=script&lang=js"
export * from "./MitMyEventsPage.vue?vue&type=script&lang=js"
import style0 from "./MitMyEventsPage.vue?vue&type=style&index=0&id=2ddcfdea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddcfdea",
  null
  
)

export default component.exports